import { Form, InputNumber } from "antd";
import { COMMONS } from "common";
import React from "react";
import styled from "styled-components";

export const StyledCustomInputNumber = styled.div`
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.ant-input-number-handler-wrap {
		display: none;
	}
`;

const CustomInputNumber = (props) => {
	const {
		name,
		label,
		rules,
		maxLength,
		parser,
		formItemClassName,
		formItemStyle,
		...rest
	} = props;

	const defaultParser = (value) => {
		return value
			.replace(COMMONS.REGEX_REMOVE_NON_DIGIT, "")
			.slice(0, COMMONS.MAX_LENGTH_INPUT_NUMBER);
	};

	return (
		<StyledCustomInputNumber
			className={formItemClassName}
			style={formItemStyle}
		>
			<Form.Item name={name} label={label} rules={rules}>
				<InputNumber
					onPressEnter={(e) => {
						e.preventDefault();
					}}
					min={0}
					stringMode
					maxLength={maxLength ?? COMMONS.MAX_LENGTH_INPUT_NUMBER}
					parser={parser ?? defaultParser}
					{...rest}
				/>
			</Form.Item>
		</StyledCustomInputNumber>
	);
};

export default CustomInputNumber;
